<template>
  <a-modal
    :visible="visible"
    title="确认发布"
    width="680px"
    :footer="null"
    :closable="!confirmLoading"
    :mask-closable="false"
    :body-style="{ maxHeight: 'calc(100vh - 220px)', overflowY: 'auto' }"
    @cancel="handleCancel"
  >
    <section class="change-section">
      <h4>本次变更（与线上版本对比）</h4>
      <ul>
        <li v-for="item in changes" :key="item">{{ item }}</li>
      </ul>
    </section>

    <a-form ref="formRef" :model="form" :rules="rules" layout="vertical">
      <a-form-item label="版本说明" name="releaseNote">
        <a-textarea
          v-model:value="form.releaseNote"
          :rows="3"
          :maxlength="1000"
          show-count
          placeholder="例：黑五主会场 Tab 上线"
        />
      </a-form-item>
    </a-form>

    <div class="modal-footer">
      <a-button :disabled="confirmLoading" @click="handleCancel">
        再想想
      </a-button>
      <a-button type="primary" :loading="confirmLoading" @click="handleConfirm">
        确认发布
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { reactive, ref, watch } from 'vue'

export default {
  name: 'PublishConfigModal',
  props: {
    visible: Boolean,
    changes: {
      type: Array,
      default: () => []
    },
    confirmLoading: Boolean
  },
  emits: ['update:visible', 'confirm'],
  setup(props, { emit }) {
    const formRef = ref()
    const form = reactive({ releaseNote: '' })
    const rules = {
      releaseNote: [
        {
          required: true,
          whitespace: true,
          message: '请输入版本说明',
          trigger: 'blur'
        },
        {
          max: 1000,
          message: '版本说明不能超过 1000 个字符',
          trigger: 'blur'
        }
      ]
    }

    const resetForm = () => {
      form.releaseNote = ''
      formRef.value?.clearValidate()
    }
    const handleCancel = () => {
      if (props.confirmLoading) return
      emit('update:visible', false)
    }
    const handleConfirm = async () => {
      try {
        await formRef.value.validate()
        emit('confirm', form.releaseNote.trim())
      } catch {
        return
      }
    }

    watch(
      () => props.visible,
      visible => {
        if (!visible) resetForm()
      }
    )

    return {
      form,
      formRef,
      handleCancel,
      handleConfirm,
      rules
    }
  }
}
</script>

<style lang="scss" scoped>
.change-section {
  margin-bottom: 20px;

  h4 {
    margin-bottom: 10px;
    color: #595959;
    font-weight: 600;
  }

  ul {
    margin: 0;
    padding-left: 22px;
    color: #595959;
  }

  li {
    padding: 3px 0;

    &::marker {
      color: #cf3e0d;
    }
  }
}

.modal-footer {
  display: flex;
  margin-top: 24px;
  justify-content: flex-end;
  gap: 12px;

  .ant-btn {
    min-width: 96px;
    height: 40px;
  }
}
</style>
